import type { IMarket } from "@apis/accounts/types"
import { baseServiceRequest } from "../baseServiceRequest"
import type {
  IOffer,
  IOffersRequest,
  IOffersResponse,
} from "@commonTypes/offer"
import type { AxiosResponse } from "axios"
import type {
  IContractType,
  ISaveOfferRequest,
  IPlan,
  IPlanRewardsResponse,
} from "./types"

export const getOffer = async (offer_code: string): Promise<IOffer> => {
  const response = await baseServiceRequest({
    method: "GET",
    url: `/offers/${offer_code}`,
  })
  return response.data
}

export const getMarketsByZipCode = async (
  zip_code: string,
): Promise<IMarket[]> => {
  const response = await baseServiceRequest({
    method: "GET",
    url: `/offers/markets/${zip_code}`,
  })
  return response.data
}

export const getDynamicOffers = async (
  data: IOffersRequest,
): Promise<AxiosResponse<IOffersResponse>> => {
  return await baseServiceRequest({
    method: "POST",
    url: `/offers/dynamic`,
    data,
  })
}

export const getRecentlyViewedOffers = async (
  market_code: string,
  prospect_guid: string,
): Promise<AxiosResponse<IOffer[]>> => {
  return await baseServiceRequest({
    method: "GET",
    url: `/offers/market/${market_code}/prospects/${prospect_guid}`,
  })
}

export const getContractTypes = async (): Promise<IContractType[]> => {
  const response = await baseServiceRequest({
    method: "GET",
    url: `/offers/contract_types`,
  })
  return response.data
}

export const getAllPlans = async (): Promise<IPlan[]> => {
  const response = await baseServiceRequest({
    method: "GET",
    url: `/offers/plans/all`,
    params: {
      active_only: true,
    },
  })
  return response.data
}

export const getPlansSOP = async (): Promise<IPlan[]> => {
  const response = await baseServiceRequest({
    method: "GET",
    url: `/offers/plans/sop`,
  })
  return response.data
}

export const getPlanRewards = async (
  plan_code: string,
): Promise<IPlanRewardsResponse> => {
  const response = await baseServiceRequest({
    method: "GET",
    url: `offers/plans/${plan_code}/promos_and_loyalty_programs`,
  })
  return response.data
}

export const findOrCreateOffer = async ({
  data,
}: {
  data: ISaveOfferRequest
}): Promise<IOffer> => {
  const response = await baseServiceRequest({
    method: "POST",
    url: "/offers",
    data,
  })
  return response.data
}

export const getMarkets = async (): Promise<IMarket[]> => {
  const response = await baseServiceRequest({
    method: "GET",
    url: "/offers/markets",
  })
  return response.data
}
